<template>
  <div class="contact-types-block">
    <vx-card title="Contact Types" class="mb-6">
      <p>Select the contact types the user will be asked to select from when checking in to this location.</p>
      <vs-table :data="location.contactTypes">
        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>Visible</vs-th>
          <vs-th>Questions</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Department/Company Name</vs-th>
          <vs-th>Host</vs-th>
          <vs-th>Dependants</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr class="hoverFlat" :key="i" v-for="(ct, i) in data" ref="templateRow">
            <vs-th>{{ ct.name }}</vs-th>
            <vs-td><vs-checkbox class="block" v-model="ct.selected" :disabled="isArchivedLocation"></vs-checkbox></vs-td>
            <vs-td>
              <div v-if="ct.selected">
                <vx-field
                  type="v-select"
                  class="w-full min-w-48"
                  :appendToBody="true"
                  v-model="ct.questionSet"
                  placeholder="--Default--"
                  :options="{
                    text: 'name',
                    items: (questionSets || {}).items || []
                  }"
                  :disabled="isArchivedLocation"
                >
                  <template #option="option">
                    <div class="questions-option">
                      <p><strong>{{ option.name }}</strong></p>
                      <div class="pl-5" v-if="option.questionSetItems.length > 0">
                        <div v-for="(q, i) in option.questionSetItems" :key="i" class="truncate text-xs flex">
                          <strong>{{ `${i + 1}. ` }}</strong>
                          <div class="ml-2" v-html="q.question.question"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-field>
              </div>
            </vs-td>

            <vs-td>
              <div v-if="ct.selected">
                <vx-field
                  type="select"
                  autocomplete
                  v-model="ct.rules.email"
                  :options="{
                    items: ruleOptions || []
                  }"
                  :disabled="isArchivedLocation"
                />
              </div>
            </vs-td>
            <vs-td>
              <div v-if="ct.selected">
                <vx-field
                  type="select"
                  autocomplete
                  v-model="ct.rules.companyName"
                  :options="{
                    items: ruleOptions || []
                  }"
                  :disabled="isArchivedLocation"
                />
              </div>
            </vs-td>
            <vs-td>
              <div v-if="ct.selected">
                <vx-field
                  type="select"
                  autocomplete
                  v-model="ct.rules.host"
                  :options="{
                    items: ruleOptions || []
                  }"
                  :disabled="isArchivedLocation"
                />
              </div>

            </vs-td>
            <vs-td>
              <div v-if="ct.selected">
                <vx-field
                  type="select"
                  autocomplete
                  v-model="ct.rules.dependants"
                  :options="{
                    items: ruleOptions || []
                  }"
                  :disabled="isArchivedLocation"
                />
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <vs-button
        class="ml-auto vx-row__actions"
        @click.prevent="saveChanges()"
        icon-pack="feather" icon="icon-check" icon-before :disabled="isArchivedLocation">Save Changes</vs-button>
    </vx-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue'

export default {
  props: ['location', 'isArchivedLocation'],
  data () {
    return {
      ruleOptions: [
        {
          value: 0,
          text: 'Optional'
        }, {
          value: 2,
          text: 'Required'
        }, {
          value: 4,
          text: 'Hidden'
        }
      ]
    }
  },
  computed: {
    ...mapState('visitManagement', ['contactTypes', 'questionSets']),
    hasRules () {      
      return (tr) => {
        var visible = false;
        const locationsContactTypes = (this.location || {}).contactTypes;
        if (locationsContactTypes) {
          try {
            for (let i = 0; i < locationsContactTypes.length; i++) {
              const item = locationsContactTypes[i];
              if (item.id == tr.id) {
                visible = !!item.rules;
                break;
              }
            }
          }
          catch (error) {
            
          }
        }
        return visible;
      }
    },
  },
  methods: {
    async filter () {
      await this.$store.dispatch('visitManagement/fetchContactTypes', { limit: 1000 });

    },
    saveChanges () {
      this.$store
        .dispatch('visitManagement/updateLocation',  this.location)
        .then(res => {
          this.$emit('success', res.data);
        });
    }
  },
  async created () {
    await this.filter()

  },
  async mounted() {
      

  }
}
</script>

<style lang="scss">
  .con-select {
    min-width: 100px;
    max-width: 200px;
    width: auto !important;
  }
  .vs__dropdown-menu {
    width: fit-content !important;
  }
</style>